import React from 'react';
import classNames from 'classnames';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import styles from './skeleton.scss';
import { SKELETON } from '../../../common/constants/data-hooks';
const Skeleton = ({ showSkeleton, children, }) => {
    const { screenshotMode } = useConfiguration();
    const [shouldRenderSkeleton, setShouldRenderSkeleton] = React.useState(showSkeleton);
    React.useLayoutEffect(() => {
        if (!showSkeleton) {
            const timeoutId = setTimeout(() => {
                setShouldRenderSkeleton(false);
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [showSkeleton]);
    return (React.createElement("div", { className: styles.root },
        shouldRenderSkeleton && (React.createElement("div", { "data-hook": SKELETON, className: classNames(styles.skeleton, {
                [styles.fade]: !showSkeleton,
                [styles.pulse]: !screenshotMode,
            }) })),
        React.createElement("div", { className: classNames(styles.content, {
                [styles.hidden]: showSkeleton && shouldRenderSkeleton,
            }) }, children)));
};
export default Skeleton;
//# sourceMappingURL=skeleton.js.map